import { render, staticRenderFns } from "./forms-category.vue?vue&type=template&id=05413e85&"
import script from "./forms-category.vue?vue&type=script&lang=js&"
export * from "./forms-category.vue?vue&type=script&lang=js&"
import style0 from "./forms-category.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports